import type { OrganizationRoles } from '~/constants/organizations'
import type { WorkspaceRoles } from '~/constants/workspaces'

export const isUserGranted = (
  userRole: OrganizationRoles | WorkspaceRoles,
  minimumRole: OrganizationRoles | WorkspaceRoles,
) => {
  return userRole >= minimumRole
}
